import * as React from "react";
import { Stack } from "@mui/material";
import { StatusCard } from "@/components/dashboard/StatusCard";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { ExecutionTimeline } from "@/components/dashboard/ExecutionTimeline";
import { OrderTable, type OrderRow } from "../OrderTable";
import { useOrderBook } from "@/hooks/queries/useOrderBook";

interface ExecutionOrderPayload {
  execution_id: string;
  instrument_token: string;
  side: string;
  quantity: number;
  status: string;
}

export function OrdersTableSection(): React.JSX.Element {
  const orderBookQuery = useOrderBook();

  return (
    <Stack spacing={3}>
      <StatusCard title="Orders Table">
        <QueryStateBoundary
          query={orderBookQuery}
          isEmpty={(data) => (data as unknown as ExecutionOrderPayload[]).length === 0}
          emptyMessage="No orders reported by the backend."
        >
          {(payload) => {
            const rows: OrderRow[] = (payload as unknown as ExecutionOrderPayload[]).map((o) => ({
              execution_id: o.execution_id,
              instrument_token: o.instrument_token,
              side: o.side,
              quantity: o.quantity,
              status: o.status,
            }));
            return <OrderTable orders={rows} />;
          }}
        </QueryStateBoundary>
      </StatusCard>
      <StatusCard title="Execution Timeline">
        <QueryStateBoundary query={orderBookQuery}>
          {(payload) => {
            const orders = payload as unknown as ExecutionOrderPayload[];
            return (
              <ExecutionTimeline
                items={orders.map((o) => ({
                  id: o.execution_id,
                  label: `${o.instrument_token} — ${o.side} ${o.quantity}`,
                  status: o.status,
                }))}
                emptyMessage="No orders reported by the backend."
              />
            );
          }}
        </QueryStateBoundary>
      </StatusCard>
    </Stack>
  );
}
